import api from '@/lib/api';

export interface WorkspaceApiItem {
  authUserId?: string;
  workspaceId: string;
  workspaceName?: string;
  userId?: string;
  role?: string;
  [key: string]: any;
}

// Selection-only: Fetch workspaces available to the current user for choosing a workspace context.
// This module is intended to be used ONLY inside the selection flow (e.g., SelectWorkspace page).
export async function getUserWorkspaces(authUserId?: string | null): Promise<WorkspaceApiItem[]> {
  const resp = await api.get('/v1/Workspace/GetUserWorkspaces', {
    params: { authUserId: authUserId ?? undefined },
  });

  const payload = resp.data || {};
  const items = Array.isArray(payload.data) ? payload.data : [];
  return items as WorkspaceApiItem[];
}

export default {
  getUserWorkspaces,
};
